const validateVariantId = (inputs, parent) => {
  const draftcolors = Array.from(inputs).map(input => input.dataset.color)
  const colors = [...new Set(draftcolors)]
  const options = parent.querySelectorAll(".color-swatch");
  const loader = parent.querySelector(".product-card-loader");
  const image = parent.querySelector(".product-card-main-image");
  image.style.opacity = 0
  let isClicked = false

  options.forEach((colorOption, i) => {
    if(colors.includes(colorOption.attributes.value.value)) {
      if(!isClicked) {
        colorOption.click()
        isClicked = true
      }
      if(i === 0) {
        loader.classList.add("d-none")
        image.style.opacity = 1
      }
      image.addEventListener("load", ()=> {
        loader.classList.add("d-none")
        image.style.opacity = 1
      })
    } else {
      colorOption.classList.add("d-none")
    }
  })

  const anyVariant = [...options].every((element) => element.classList.contains('d-none'));
  
  if (anyVariant) {
    parent.classList.add("d-none")
  }

}

const validateProductNew = (product) => {
  let haveNewTag = false
  const newTags = product.querySelectorAll('.product-badges-sources input[value*="Nuevo"]')

  if(newTags.length > 0) {
    validateVariantId(newTags, product)
    haveNewTag = true
  }

  if (haveNewTag === false) {
    product.classList.add("d-none")
  }
}

const hideProductOptions = () => {
  const products = document.querySelectorAll(".product-item")
  
  products.forEach(product => {
    validateProductNew(product)
  })
}

hideProductOptions()